import type { MessageUiState } from "../services/api";

/** Escape text for safe insertion as HTML text content. */
function escapeHtmlText(s: string): string {
  const d = document.createElement("div");
  d.textContent = s;
  return d.innerHTML;
}

/**
 * Builds the one-line summary shown after a clarification form is submitted
 * (persisted in `message.ui_state`, not DOM-only state).
 */
export function buildClarificationSummaryText(uiState: MessageUiState | undefined): string | null {
  const c = uiState?.clarification;
  if (!c?.submitted) return null;

  if (c.composed_preview?.trim()) {
    const body = c.composed_preview
      .trim()
      .split(/\n+/)
      .map((line) => line.trim())
      .filter(Boolean)
      .join(", ");
    return `For clarification, user selected: ${body}`;
  }

  if (c.field_values && Object.keys(c.field_values).length > 0) {
    const parts = Object.entries(c.field_values).map(([k, v]) => `${k}: ${v}`);
    return `For clarification, user selected: ${parts.join(", ")}`;
  }

  return "For clarification, the form was submitted.";
}

/**
 * Replaces each `data-av-clarification` block with a static summary (callout above is unchanged).
 */
export function replaceClarificationBlocksWithSummary(
  container: HTMLElement,
  summary: string
): void {
  const safe = escapeHtmlText(summary);
  container.querySelectorAll<HTMLElement>("[data-av-clarification]").forEach((root) => {
    if (root.querySelector(".av2-clarification-summary")) return;
    root.innerHTML = `<div class="av2-clarification-summary" role="status">${safe}</div>`;
  });
}
